import { useEffect, useState, useRef } from "react";
import { loadStripe } from "@stripe/stripe-js";

export const usePaymentSDKValidation = (restaurantsDetail) => {
  const [paypalSdkValid, setPaypalSdkValid] = useState(false);
  const [stripeSdkValid, setStripeSdkValid] = useState(false);
  const hasCheckedSDKs = useRef(false);

  useEffect(() => {
    if (hasCheckedSDKs.current || !restaurantsDetail) return;
    hasCheckedSDKs.current = true;

    const stripeKey = restaurantsDetail?.stripeClientKey;
    const paypalKey = restaurantsDetail?.paypalClientKey;

    const checkStripe = async () => {
      if (!stripeKey) return;

      try {
        const stripe = await loadStripe(stripeKey);
        if (stripe) {
          setStripeSdkValid(true);
        } else {
          console.warning("Stripe SDK failed to load.");
        }
      } catch {
        console.warning("Stripe SDK failed to load.");
      }
    };

    const checkPayPal = () => {
      if (!paypalKey) return;

      const script = document.createElement("script");
      script.src = `https://www.paypal.com/sdk/js?client-id=${paypalKey}&currency=USD`;
      script.async = true;
      script.defer = true;

      script.onload = () => {
        if (window.paypal) {
          setPaypalSdkValid(true);
        } else {
          console.warning("PayPal SDK failed to load.");
        }
      };

      script.onerror = () => {
        console.warn("PayPal SDK script load error.");
      };

      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    };

    checkStripe().then(() => {
      checkPayPal();
    });
  }, [restaurantsDetail]);

  return { paypalSdkValid, stripeSdkValid };
};
